module.exports = __webpack_public_path__ + "img/17_2.85d8c309.png";